import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllSpeakings = () => apiClient.get(ENDPOINTS.SPEAKING.BASE);

export const getSpeakingById = (id) => apiClient.get(`${ENDPOINTS.SPEAKING.BASE}/${id}`);

export const createSpeaking = (speakingData) => apiClient.post(ENDPOINTS.SPEAKING.BASE, speakingData);

export const updateSpeaking = (id, speakingData) => apiClient.put(`${ENDPOINTS.SPEAKING.BASE}/${id}`, speakingData);

export const deleteSpeaking = (id) => apiClient.delete(`${ENDPOINTS.SPEAKING.BASE}/${id}`);
